<template>
  <div class="carousel-pictures" v-loading="loadingImg" :style="{ height: (contenitoreHeight)+ 'px'}">
    <div class="box">
      <div class="titolo">
        <span>{{ $t('carousel.title').toUpperCase() }}</span>
      </div>
      <el-carousel arrow="never" :autoplay="true" :interval="5000" indicator-position="outside" trigger="click" :style="{ height: (contenitoreHeight - 30 - 22)+ 'px'}">
        <el-carousel-item v-for="image in images" :key="image.keyDoc">
          <div class="pictures-name truncate">
            <span>{{ image.titolo.toUpperCase() }}</span>
          </div>
          <div class="pictures pointer">
            <img :src="image.link" onclick="window.open(this.src)">
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      contenitoreHeight: {
        type: Number
      },
      loadingImg: {
        required: true,
        type: Boolean,
        default: false
      },
      ['images']: {
        type: Array,
        required: true,
        default: []
      }
    },
    name: 'CarouselPictures',
    i18n: {
      messages: {
        it_IT: {
          carousel: {
            title: 'Info'
          }
        },
        fr_FR: {
          carousel: {
            title: 'Infos'
          }
        },
        es_ES: {
          carousel: {
            title: 'Info'
          }
        },
        en_GB: {
          carousel: {
            title: 'Infos'
          }
        },
        de_DE: {
          carousel: {
            title: 'Information'
          }
        }
      }
    },
    data () {
      return {
      }
    },
    computed: {
    },
    mounted: function () {
    },
    methods: {
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .carousel-pictures {
    min-height: 450px;
    // height: 100%;
    padding-bottom: 10px;
    .box {
      // height: 100%;
      overflow: auto;
      /*border: 1px solid #e7e7e7;
      border-radius: 4px;
      -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
      -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
      box-shadow: 0px 0px 13px 1px #e7e7e7;*/
      padding: 10px;
      .titolo {
        width: 100%;
        .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
        text-align: left;
        line-height: 30px;
        height: 30px;
        letter-spacing: 2px;
      }
      .el-carousel {
        height: 100%;
        .el-carousel__container{
          height: calc(100% - 32px);
          .el-carousel__item {
            .pictures-name {
              width: 100%;
              .set-font(@color: #B03488, @size: 14px, @family: 'os-semibolditalic');
              text-align: right;
              line-height: 25px;
              height: 25px;
              letter-spacing: 1px;
              text-transform: uppercase;
            }
            .pictures {
              img {
                width: 100%;
              }
            }
          }
        }
        .top-block {
          width: 100%;
          .set-font(@color: #B03488, @size: 12px, @family: 'os-semibolditalic');
          text-align: right;
          line-height: 20px;
          height: 20px;
        }
        .linkDetail {
          height: 40px;
          line-height: 30px;
          position: relative;
          padding-bottom: 10px;
          display: flex;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: lowercase;
          a {
          .set-font(@size: 13px; @color: @grayTesto; @family: 'os-lightitalic');
          .applicazione {
            text-transform: uppercase;
            .set-font(@size: 14px, @color: #485eb5, @weight: bold, @family:'os-regular');
          }
          .url {
            text-transform: lowercase;
            .set-font(@size: 13px; @color: @grayTesto; @family: 'os-lightitalic');
          }
          }
          a:hover {
            text-decoration: none;
          }
          a:focus {
            text-decoration: none;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/HomePage/CarouselPictures.vue